
























































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import EyeIcon from 'mdi-vue/Eye';
import EyeCloseIcon from 'mdi-vue/EyeOff';

@Component({
  components: {
    Button,
    EyeIcon,
    EyeCloseIcon,
  },
})
export default class FormInput extends Vue {
  @Prop({ type: String, default: '' }) readonly variant!: string;
  @Prop(String) readonly rules!: string;
  @Prop({ default: false }) readonly disabled!: string;
  @Prop(String) readonly label!: string;
  @Prop(String) readonly value!: string;
  @Prop(String) readonly vid!: string;
  @Prop(Number) readonly maxlength!: number;
  @Prop(String) readonly name!: string;
  @Prop(Boolean) readonly numbersOnly!: boolean;
  @Prop(Boolean) readonly isEmail!: boolean;
  @Prop(Boolean) readonly disableSpace!: boolean;
  @Prop(String) readonly placeholder!: string;
  @Prop(String) subtitle!: string;
  @Prop({ type: String, default: 'text' }) readonly type!: string;
  @Prop(String) readonly textAlign!: string;
  @Prop(Boolean) readonly autofocus!: boolean;
  @Prop({ default: '' }) readonly error!: string;
  @Prop(Object) readonly customErrorMessages: undefined | { [key: string]: string };
  @Prop(Function) readonly action: undefined | (() => void);
  @Prop(String) readonly suffix?: string;
  @Prop({ type: String, default: '' }) isError?: string;

  $refs!: {
    input: HTMLInputElement;
  }

  passwordVisible = false;
  inputType = this.type;
  isInputError = this.isError;

  togglePasswordVisible() {
    this.passwordVisible = !this.passwordVisible;
    this.inputType = this.passwordVisible ? 'text' : 'password';
  }

  focus() {
    this.$refs.input.focus();
  }

  @Watch('value')
  isNumber() {
    if (this.numbersOnly) {
      this.inputVal = this.inputVal.replaceAll(/[^\d]/g, '');
    } else if (this.isEmail) {
      // eslint-disable-next-line no-useless-escape
      this.inputVal = this.inputVal.replaceAll(/[&\/\\#,()$~%'^":*?<>;!{}]/g, '');
    }
    this.isInputError = '';
  }

  get inputVal() {
    return this.value;
  }

  set inputVal(val) {
    this.$emit('input', val);
  }
}
